export * from "./getProvinceCodeTranslationKey";
